<div class="card card-danger">
  <div class="card-header">
    <div class="float-left"><h5> RatingProfiles </h5></div>
    <div class="float-right">
      <div class="btn-group" role="group" aria-label="Basic example">
        <button (click)="showFind()" type="button" class="btn btn-sm btn-outline-info"><i class="fa fa-search" aria-hidden="true"></i> Find</button>
        <button (click)="showNew()" type="button" class="btn btn-sm btn-outline-success"><i class="fa fa-plus" aria-hidden="true"></i> Add new </button>
      </div>
    </div>
  </div>

  <div class="card-body">
    <div class="row">
      <div class="col">

        <div *ngIf="mode==formModes.Find">
          <div class="row" style="margin-left: 0px;">
            <div class="col-sm-6">
              <div class="form-group row">
                <label for="Name" class="col-sm-3 col-form-label" style="position: relative; top: 6px;">Name</label>
                <div class="col-sm-9" style="margin-left: -64px; height: 0px;">
                  <!-- <input [(ngModel)]="ratingProfileName" maxlength="50" class="form-control form-control-sm" #name="ngModel" type="text" id="Name" name="Name"/> -->
                  <mat-form-field appearance="outline">
                    <mat-label>Name</mat-label>
                    <input matInput [(ngModel)]="ratingProfileName" maxlength="50" #name="ngModel" type="text" id="Name" name="Name" />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12" style="position: relative; top: 16px;">
              <div class="text-center m-3">
                <button type="button" (click)="onSubmit()" class="btn btn-sm btn-info mx-1"><i class="fa fa-search" aria-hidden="true"></i> Search </button>
                <button type="button" class="btn btn-sm btn-outline-secondary mx-1" style="color: white; background-color: #2f72ab;" (click)="resetForm()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel </button>
              </div>
              <br />
            </div>
          </div>
        </div>

        <div *ngIf="mode==formModes.New || mode==formModes.Edit" style="margin-left: 80px;">
          <form #f="ngForm" (ngSubmit)="onSubmit(f)">
            <div class="row" style="margin-right: -41px">
              <div class="col-sm-6">

                <div class="form-group row">
                  <label for="Name" class="col-sm-3 col-form-label">Name</label>
                  <div class="col-sm-9">
                    <mat-form-field appearance="outline">
                      <mat-label>Enter profile name   </mat-label>
                      <input matInput [(ngModel)]="model.profileName" required maxlength="50" #name="ngModel" type="text" id="name" name="name">
                    </mat-form-field>
                    <div *ngIf="name.invalid && (name.dirty && name.touched)" class="text-danger small">
                      <div *ngIf="name.errors.required">
                        Profile name is required.
                      </div>
                      <div *ngIf="name.errors.maxlength">
                        Profile name must be less than 50 characters long.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="Description" class="col-sm-3 col-form-label">Description</label>
                  <div class="col-sm-9">
                    <mat-form-field appearance="outline">
                      <mat-label>Enter description   </mat-label>
                      <textarea matInput [(ngModel)]="model.description" required #description="ngModel" type="text" id="description" name="description"
                                cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"></textarea>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">

                <div class="form-group row">
                  <label for="CreatedAt" class="col-sm-3 col-form-label">Created</label>
                  <div class="col-sm-9">
                    <mat-form-field appearance="outline">
                      <mat-label>Created</mat-label>
                      <input matInput [(ngModel)]="model.createdAt" disabled #apiKey="ngModel" type="text" id="CreatedAt" name="CreatedAt">
                    </mat-form-field>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="ModifiedAt" class="col-sm-3 col-form-label">Modified</label>
                  <div class="col-sm-9">
                    <mat-form-field appearance="outline">
                      <mat-label>ModifiedAt</mat-label>
                      <input matInput [(ngModel)]="model.modifiedAt" disabled #apiKey="ngModel" type="text" id="ModifiedAt" name="ModifiedAt">
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                  <div class="text-center m-3">
                    <!--<button type="button" (click)="showMappingsModal()" *ngIf="this.isRateFileButtonDisplay == true" class="btn btn-sm btn-info mx-1"> <i class="fa fa-file-excel-o" aria-hidden="true"></i> Map Carrier Rate Files</button>-->
                    <button type="submit" [disabled]="f.invalid" *ngIf="mode==formModes.New" class="btn btn-sm btn-success mx-1"><i class="fa fa-plus" aria-hidden="true"></i> Save </button>
                    <button type="submit" [disabled]="f.invalid" *ngIf="mode==formModes.Edit" class="btn btn-sm mx-1" style="color: white; background-color: #2f72ab;"><i class="fa fa-floppy-o" aria-hidden="true"></i> Update </button>
                    <button type="button" class="btn btn-sm btn-outline-secondary mx-1" style="color: white; background-color: #2f72ab;" (click)="resetForm()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel </button>
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </form>
          <div class="row" *ngIf="mode==formModes.Edit">

            <!-- Service Discounts -->
            <div class="row" id="serviceDiscountsGrid" style="margin-top: 5vh">
              <h2>Service Discounts</h2>
              <div class="row">
                <div [formGroup]="serviceDiscountsFilterForm">
                  <div class="col-sm-1" style="display:inline-flex">
                    <label>Filters</label>
                  </div>
                  <div class="col-sm-3" style="display:inline-flex">
                    <mat-form-field appearance="outline" [panelWidth]="auto" style="width:350px">
                      <mat-label>Service     </mat-label>
                      <mat-select formControlName="serviceType">
                        <mat-option *ngFor="let service of availableServices" [value]="service.serviceCode">
                          {{service.plainText}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-sm-2" style="display:inline-flex">
                    <mat-form-field appearance="outline">
                      <mat-label>Packaging     </mat-label>
                      <mat-select formControlName="packaging">
                        <mat-option [value]="'CUSTOM'">Custom</mat-option>
                        <mat-option *ngFor="let opt of availablePackagingTypes" [value]="opt.value">
                          {{opt.label}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                </div>
              </div>
              <div class="row">
                <ng-container *ngIf="serviceDiscounts.length == 0">
                  <div class="col-sm-4 offset-2" style="padding-bottom:3vh">
                    <label>No results found</label>
                  </div>
                </ng-container>
                <ng-container *ngIf="serviceDiscounts.length > 0">
                  <div class="col-sm-12">

                    <div [formGroup]="serviceDiscountsForm">
                      <ng-container formArrayName="serviceDiscounts" class="row">
                        <ng-container *ngFor="let serviceDiscountForm of serviceDiscounts.controls; let i = index">
                          <div formGroupName="{{i}}">
                            <div class="col-sm-3" style="display:inline-flex">
                              <mat-form-field appearance="outline" [panelWidth]="auto" style="width:350px">
                                <mat-label>Service     </mat-label>
                                <mat-select formControlName="serviceType">
                                  <mat-option *ngFor="let service of availableServices" [value]="service.serviceCode">
                                    {{service.plainText}}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div class="col-sm-2" style="display:inline-flex">
                              <mat-form-field appearance="outline">
                                <mat-label>Packaging     </mat-label>
                                <mat-select formControlName="packaging">
                                  <mat-option [value]="'CUSTOM'">Custom</mat-option>
                                  <mat-option *ngFor="let opt of availablePackagingTypes" [value]="opt.value">
                                    {{opt.label}}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <ng-container *ngIf="getPackagingValue(i) == 'CUSTOM'">
                              <div class="col-sm-1" style="display:inline-flex">
                                <mat-form-field appearance="outline">
                                  <mat-label>Min Wt</mat-label>
                                  <input type="number" matInput formControlName="minWeight" />
                                </mat-form-field>
                              </div>
                              <div class="col-sm-1" style="display:inline-flex">
                                <mat-form-field appearance="outline">
                                  <mat-label>Max Wt</mat-label>
                                  <input type="number" matInput formControlName="maxWeight" />
                                </mat-form-field>
                              </div>
                            </ng-container>
                            <div class="col-sm-1" style="display:inline-flex">
                              <mat-form-field appearance="outline">
                                <mat-label>Zones       </mat-label>
                                <input type="text" matInput formControlName="zones" />
                              </mat-form-field>
                            </div>
                            <div class="col-sm-1" style="display:inline-flex">
                              <mat-form-field appearance="outline">
                                <mat-label>Discount %       </mat-label>
                                <input type="text" matInput formControlName="discountPercentage" />
                              </mat-form-field>
                            </div>
                            <div class="col-sm-1" style="display:inline-flex">
                              <mat-form-field appearance="outline">
                                <mat-label>Min Charge</mat-label>
                                <input type="text" matInput formControlName="minimumCharge" />
                              </mat-form-field>
                            </div>

                            <div class="col-sm-2" style="display: inline-flex;height:45px">
                              <button type="button" (click)="deleteServiceDiscount(i)" class="btn btn-danger mx-1">
                                <i class="fa fa-trash" aria-hidden="true"></i>
                                Delete
                              </button>
                              <!--<button type="button" (click)="saveServiceDiscount(serviceDiscountForm)" class="btn btn-info mx-1">
                <i class="fa fa-save" aria-hidden="true"></i>
                Save
              </button>-->
                            </div>
                          </div>
                        </ng-container>

                      </ng-container>

                    </div>
                  </div>
                </ng-container>
              </div>
                <div class="row">
                  <div class="col-sm-3">
                    <button type="button" (click)="addServiceDiscount()" class="btn btn-info mx-1"> + Add Service Discount</button>
                  </div>
                </div>

              </div>


              <!-- Accessorial Discounts -->
              <div class="row" id="accessorialDiscountsGrid" style="margin-top: 5vh">
                <h2>Accessorial Discounts</h2>
                <div class="row">
                  <div class="col-sm-12">

                    <div [formGroup]="accessorialDiscountsForm">
                      <ng-container formArrayName="accessorialDiscounts" class="row">
                        <ng-container *ngFor="let accessorialDiscountForm of accessorialDiscounts.controls; let i = index">
                          <div formGroupName="{{i}}">
                            <mat-form-field appearance="outline">
                              <mat-select formControlName="serviceType">
                                <mat-option [value]="'*'">All</mat-option>
                                <mat-option *ngFor="let service of availableServices" [value]="service.serviceCode">
                                  {{service.plainText}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                              <mat-select formControlName="accessorialCode">
                                <mat-option [value]="null">None</mat-option>
                                <mat-option *ngFor="let acc of availableAccessorials" [value]="acc.value">
                                  {{acc.label}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                            <div class="col-sm-1" style="display:inline-flex">
                              <mat-form-field appearance="outline">
                                <mat-label>Min Wt</mat-label>
                                <input type="number" matInput formControlName="minWeight" />
                              </mat-form-field>
                            </div>
                            <div class="col-sm-1" style="display:inline-flex">
                              <mat-form-field appearance="outline">
                                <mat-label>Max Wt</mat-label>
                                <input type="number" matInput formControlName="maxWeight" />
                              </mat-form-field>
                            </div>
                            <div class="col-sm-1" style="display:inline-flex">
                              <mat-form-field appearance="outline">
                                <mat-label>Zones</mat-label>
                                <input type="text" matInput formControlName="zones" />
                              </mat-form-field>
                            </div>
                            <div class="col-sm-1" style="display:inline-flex">
                              <mat-form-field appearance="outline">
                                <mat-label>Discount (%)</mat-label>
                                <input type="text" matInput formControlName="discountPercentage" />
                              </mat-form-field>
                            </div>
                            <div class="col-sm-1" style="display:inline-flex">
                              <mat-form-field appearance="outline">
                                <mat-label>Rate ($)</mat-label>
                                <input type="text" matInput formControlName="flatRateOverride" />
                              </mat-form-field>
                            </div>

                            <div class="col-sm-3" style="display: inline-flex;height:45px">
                              <button type="button" (click)="deleteAccessorialDiscount(i)" class="btn btn-danger mx-1">
                                <i class="fa fa-trash" aria-hidden="true"></i>
                                Delete
                              </button>
                              <!--<button type="button" (click)="saveAccessorialDiscount(accessorialDiscountForm)" class="btn btn-info mx-1">
                    <i class="fa fa-save" aria-hidden="true"></i>
                    Save
                  </button>-->
                            </div>
                          </div>
                        </ng-container>

                      </ng-container>

                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-3">
                    <button type="button" (click)="addAccessorialDiscount()" class="btn btn-info mx-1"> + Add Accessorial Discount</button>
                  </div>
                </div>


              </div>


              <!-- DIM Divisor Overrides -->
              <div class="row" id="dimDivisorOverridesGrid" style="margin-top: 5vh">
                <h2>DIM Divisor Overrides</h2>
                <div class="row">
                  <div class="col-sm-12">

                    <div [formGroup]="dimDivisorsForm">
                      <ng-container formArrayName="dimDivisors" class="row">
                        <ng-container *ngFor="let dimDivisorForm of dimDivisors.controls; let i = index">
                          <div formGroupName="{{i}}">
                            <mat-form-field appearance="outline">
                              <mat-label>Service     </mat-label>
                              <mat-select formControlName="serviceType">
                                <mat-option [value]="'*'">All</mat-option>
                                <mat-option *ngFor="let service of availableServices" [value]="service.serviceCode">
                                  {{service.plainText}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                            <div class="col-sm-2" style="display:inline-flex">
                              <mat-form-field appearance="outline">
                                <mat-label>DIM Divisor</mat-label>
                                <input type="text" matInput formControlName="dimDivisor" />
                              </mat-form-field>
                            </div>

                            <div class="col-sm-4" style="display: inline-flex;height:45px">
                              <button type="button" (click)="deleteDIMDivisor(i)" class="btn btn-danger mx-1">
                                <i class="fa fa-trash" aria-hidden="true"></i>
                                Delete
                              </button>
                              <!--<button type="button" (click)="saveDIMDivisor(dimDivisorForm)" class="btn btn-info mx-1">
                    <i class="fa fa-save" aria-hidden="true"></i>
                    Save
                  </button>-->
                            </div>
                          </div>
                        </ng-container>

                      </ng-container>

                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-3">
                    <button type="button" (click)="addDIMDivisor()" class="btn btn-info mx-1"> + Add DIM Divisor Override</button>
                  </div>
                </div>


              </div>
            </div>
        </div>

        <div *ngIf="mode==formModes.Del">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group row">
                <label for="Name" class="col-sm-3 col-form-label">Name</label>
                <div class="col-sm-9">
                  <mat-form-field appearance="outline">
                    <mat-label>Enter your name</mat-label>
                    <input matInput [(ngModel)]="model.name" required maxlength="50" #name="ngModel" type="text" id="Name" name="Name" [readonly]="true">
                  </mat-form-field>
                  <div *ngIf="name.invalid && (name.dirty && name.touched)" class="text-danger small">
                    <div *ngIf="name.errors.required">
                      Name is required.
                    </div>
                    <div *ngIf="name.errors.maxlength">
                      Name must be less than 50 characters long.
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="text-center m-3">
                <button type="button" (click)="onSubmit()" class="btn btn-sm btn-danger mx-1"><i class="fa fa-times" aria-hidden="true"></i> Delete </button>
                <button type="button" (click)="resetForm()" style="color: white; background-color: #2f72ab;" class="btn btn-sm mx-1"><i class="fa fa-ban" aria-hidden="true"></i> Cancel </button>
              </div>
              <br />
            </div>
          </div>
        </div>

      </div>
    </div>

    <div *ngIf="mode != formModes.New && mode != formModes.Edit" class="row">
      <div class="col">

        <div class="mat-elevation-z8">
          <table mat-table [dataSource]="ratingProfileDataSource">

            <!-- <ng-container matColumnDef="Id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Id </th>
    <td mat-cell *matCellDef="let row">{{ row.id }}  </td>
  </ng-container> -->

            <ng-container matColumnDef="ProfileName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Profile Name </th>
              <td mat-cell *matCellDef="let row"> {{ row.profileName }} </td>
            </ng-container>
            <ng-container matColumnDef="CreatedDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Created </th>
              <td mat-cell *matCellDef="let row"> {{ row.createdAt }} </td>
            </ng-container>
            <ng-container matColumnDef="Actions">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>  </th>
              <td mat-cell *matCellDef="let row">
                <button (click)="showEdit(row)" class="btn btn-sm btn-outline-primary"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                <button (click)="copy(row)" class="btn btn-sm btn-outline-primary"><i class="fa fa-copy" aria-hidden="true"></i></button>
                <button (click)="delete(row)" class="btn btn-sm btn-outline-danger"><i class="fa fa-times" aria-hidden="true"></i></button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>


          </table>
          <!--<tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">There is no record</td>
      </tr>-->
          <span style="position: relative; left: 40%; font-size: 13px; top: 40px;">There are {{this.tabledata?.length}} records</span>
          <mat-paginator [length]="this.tabledata?.length" [pageSizeOptions]="[10, 50, 100]" aria-label="Select page of users" (page)="onChangedPageSize($event)"></mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
